import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5","key":"svg-0"}],["path",{"d":"M20.866 10.45a9 9 0 1 0 -7.815 10.488","key":"svg-1"}],["path",{"d":"M12 7v5l1.5 1.5","key":"svg-2"}]]

const IconClockBitcoin = createReactComponent('outline', 'clock-bitcoin', 'ClockBitcoin', __iconNode);

export default IconClockBitcoin;